<div class="cms-layout">
  <lib-cms-sidebar />
  <main class="layout-content">
    <router-outlet />
  </main>
</div>
@if (showDevLogin()) {
  <lib-cms-dev-login />
}
